/**
 * @generated SignedSource<<3863d174728783635c44bcf155c27667>>
 * @relayHash 7a26fb12c03f6593d71e55205bbf7a4c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 393245181d0321e6e5e486fef80724ffdc1e8a531bf4f15e521f174ed9190b34

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GrafbasePlan = "ENTERPRISE" | "GROWTH" | "TRIAL";
export type accountLayoutQuery$variables = Record<PropertyKey, never>;
export type accountLayoutQuery$data = {
  readonly viewer: {
    readonly organizations: {
      readonly nodes: ReadonlyArray<{
        readonly plan: GrafbasePlan;
        readonly slug: string;
        readonly trialExpiresAt: string | null | undefined;
      }>;
    };
    readonly " $fragmentSpreads": FragmentRefs<"selectsDataWrapperProviderAccountsFragment">;
  };
};
export type accountLayoutQuery = {
  response: accountLayoutQuery$data;
  variables: accountLayoutQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "plan",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "trialExpiresAt",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "accountLayoutQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationConnection",
              "kind": "LinkedField",
              "name": "organizations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Organization",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/),
                    (v1/*: any*/),
                    (v2/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "selectsDataWrapperProviderAccountsFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "accountLayoutQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "OrganizationConnection",
            "kind": "LinkedField",
            "name": "organizations",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v4/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7a26fb12c03f6593d71e55205bbf7a4c",
    "id": "393245181d0321e6e5e486fef80724ffdc1e8a531bf4f15e521f174ed9190b34",
    "metadata": {},
    "name": "accountLayoutQuery",
    "operationKind": "query",
    "text": "query accountLayoutQuery {\n  viewer {\n    organizations {\n      nodes {\n        slug\n        plan\n        trialExpiresAt\n        id\n      }\n    }\n    ...selectsDataWrapperProviderAccountsFragment\n    id\n  }\n}\n\nfragment accountSelectFragment on User {\n  name\n  organizations {\n    nodes {\n      slug\n      name\n      id\n    }\n  }\n}\n\nfragment selectsDataWrapperProviderAccountsFragment on User {\n  ...accountSelectFragment\n}\n"
  }
};
})();

(node as any).hash = "c438bf93193a6e0cf68205b902c75fc1";

export default node;
